import SoftBox from "components/SoftBox";
import { FlowsTable } from "layouts/Flows/components/Table";
import "cxfcomponents/LayoutContainers/DashboardLayout/portalPage.css";

export const DesignerHomeTab = () => {
  return (
    <SoftBox
      className="portal-surface-layout portal-list-layout designer-home-flows"
      sx={{
        padding: "10px",
        boxSizing: "border-box",
        backgroundColor: "var(--portal-canvas-bg)",
        width: "100%",
        height: "100%",
        overflowX: "hidden",
        overflowY: "auto"
      }}
    >
      <FlowsTable tableHeight="auto" />
    </SoftBox>
  );
};
